const getSearchParam = (searchParam: string): string => {
  const params = new URL(window.location.href).searchParams;
  const param = params.get(searchParam);
  return param;
};

export { getSearchParam };
